import React from "react";
import {
    useParams,
    useNavigate
} from "react-router-dom";
import { useSelector } from "react-redux";

import { RootState } from "../../store";
import { RoundSvg } from "../../assets/svg";

interface QuizSidebarProps {
    setSelectedOption: (option: number | null) => void;
}

const QuizSidebar: React.FC<QuizSidebarProps> = ({ setSelectedOption }) => {
    const { questions } = useSelector(
        (state: RootState) => state.quiz
    );

    const { questionId, id: quiz_id } = useParams<{ questionId: string; id: string }>();

    const navigate = useNavigate();

    const handleQuestionClick = (id: string | number) => {
        navigate(`/quiz/${quiz_id}/${Number(id) + 1}`);
        setSelectedOption(null);
    };

    const getQuestionBoxClassName = (question: any, index: number) => {
        const isCurrentQuestion = Number(questionId) === index + 1;
        let className = "quiz-question-box ";

        if (question.submitted) {
            if (question.submittedAnswer === question.correct_option_id) {
                className += "correct ";
            } else {
                className += "incorrect ";
            }
        } else {
            className += "unanswered ";
        }

        if (isCurrentQuestion) {
            className += "active ";
        }

        if (isCurrentQuestion && question.submitted) {
            className += "scaled ";
        }

        return className.trim();
    };

    return (
        <div
            style={{
                width: "100%",
                height: "100%",
                background: "#6B6B6B6E",
                borderRadius: "20px",
                backdropFilter: "blur(30px)",
            }}
        >
            <div
                style={{
                    width: "100%",
                    borderRadius: "8px",
                    display: "grid",
                    gridTemplateColumns: "repeat(4, 1fr)",
                    justifyItems: "center",
                    alignItems: "center",
                    padding: "0px 16px",
                    marginTop: "16px",
                }}
            >
                {Array.isArray(questions) ? questions.map((question, index) => (
                    <div
                        key={index}
                        className={getQuestionBoxClassName(question, index)}
                        onClick={() => handleQuestionClick(index)}
                        style={{
                            height: "47.44px",
                            width: "63.64px",
                            borderRadius: "10px",
                            margin: "4px",
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                            fontSize: "20px",
                            fontWeight: 400,
                        }}
                    >
                        {index + 1}
                    </div>
                )) : Object.entries(questions).map(([index, question]) => (
                    <div
                        key={index}
                        className={getQuestionBoxClassName(question, Number(index))}
                        onClick={() => handleQuestionClick(index)}
                        style={{
                            height: "47.44px",
                            width: "63.64px",
                            borderRadius: "10px",
                            margin: "4px",
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                            fontSize: "20px",
                            fontWeight: 400,
                        }}
                    >
                        {Number(index) + 1}
                    </div>
                ))}
            </div>

            <div
                style={{
                    padding: "15px 25px",
                    display: "flex",
                    flexDirection: "column",
                    marginTop: "20px"
                }}
            >
                <div
                    style={{
                        display: "flex",
                        alignItems: "flex-start",
                        justifyContent: "flex-start",
                        gap: "10px",
                    }}
                >
                    <div
                        style={{
                            display: "flex",
                            flexDirection: "row",
                            alignItems: "center",
                            justifyContent: "center",
                            gap: "10px",
                        }}
                    >
                        <RoundSvg color={"#ffffff25"} />
                        <p
                            style={{
                                padding: "0px",
                                margin: "0px",
                                fontSize: "14px",
                                color: "#FFF",
                            }}
                        >
                            Not Answered
                        </p>
                    </div>
                    <div
                        style={{
                            display: "flex",
                            flexDirection: "row",
                            alignItems: "center",
                            justifyContent: "center",
                            gap: "10px",
                        }}
                    >
                        <RoundSvg color={"#3EAF3F"} />
                        <p
                            style={{
                                padding: "0px",
                                margin: "0px",
                                fontSize: "14px",
                                color: "#FFF",
                            }}
                        >
                            Correct
                        </p>
                    </div>
                    <div
                        style={{
                            display: "flex",
                            alignItems: "center",
                            gap: "10px",
                        }}
                    >
                        <RoundSvg color={"#EF4444"} />
                        <p
                            style={{
                                padding: "0px",
                                margin: "0px",
                                fontSize: "14px",
                                color: "#FFF",
                            }}
                        >
                            Incorrect
                        </p>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default QuizSidebar;
